import React from 'react';

const ContactUs = () => {
  return (
    <div className="contact-us">
      <button className="contact-button"> <a href="mailto:info@singler-law.com">CONTACT US</a></button>
    </div>
  );
};
export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs.js